import { approveRequest, RequestResponse } from "@api";
import { Box, Button, Grid } from "@material-ui/core";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { Modal } from "../../../screens/dashboard";
import {
  CLEAR_FILTERS_DATA,
  UPDATE_CUSTOM_FILTER,
  UPDATE_FILTERS_DATA,
  REMOVE_ROWS,
  UNSELECT_ALL,
} from "../state";
import { TableContext } from "../table";
import { RowWrapper } from "../types";
import { Filters, filterTable, Search } from "./search-filters";
import { UAMFilters } from "./search-filters/uamFilters";
import { Form } from "@components/index";

const onApproveRequest = async (ids: number[], comments: string) => {
  return await approveRequest(ids, comments);
};

interface Props {
  onShowAdd: (stat: string) => void;
  filterStatus: string;
}

const customFilter = (
  rowsWrappers: RowWrapper<RequestResponse>[],
  filterData: Filters
): RowWrapper<RequestResponse>[] => {
  return rowsWrappers.filter((wrapper) => {
    return filterTable(wrapper.row.data, filterData);
  });
};

export const UamToolbar: React.FC<Props> = ({ filterStatus,onShowAdd }) => {
  const [open, setOpen] = useState<boolean>(false);
  const [openApprove, setOpenApprove] = useState<boolean>(false);
  const { state, dispatch } = useContext(TableContext);
  const { rows, selectedRows } = state;
  const [searchValue, setSearchValue] = useState<string>("");

  const form = Form.useManager<Filters>({
    environment: "",
    dateType: "",
    status: "",
    systemName: "",
    dateFrom: null,
    dateTo: null,
    typeOfAction: "",
  });

  useEffect(() => {
    dispatch({ type: UPDATE_CUSTOM_FILTER, customFilter });
  }, [dispatch]);

  const onSearchUpdate = useCallback(
    (term: string) => {
      setSearchValue(term);
      dispatch({
        type: UPDATE_FILTERS_DATA,
        filtersData: { searchTerm: term },
      });
    },
    [dispatch]
  );

  const onSubmitApproval = useCallback(
    async (comments: string) => {
      const ids = [];
      for (const i in selectedRows) {
        ids.push(selectedRows[i].row.data.id);
      }
      const success = await onApproveRequest(ids, comments);
      if (success) {
        dispatch({ type: REMOVE_ROWS, rows: selectedRows });
        dispatch({ type: UNSELECT_ALL });
      }
      return { success };
    },
    [dispatch, selectedRows]
  );  

  const [stat_APPROVED, setAPPROVED] = useState<boolean>(true);   
  const [stat_INPROGRESS, setINPROGRESS] = useState<boolean>(false); 
  const [stat_COMPLETED, setCOMPLETED] = useState<boolean>(false); 
  const [stat_REJECTED, setREJECTED] = useState<boolean>(false); 
  const [stat_DECLINED, setDECLINED] = useState<boolean>(false); 
  const [stat_RFDECLINED, setRFDECLINED] = useState<boolean>(false); 
  
  //apply filters
  function filterByStatus(){
    let statusFilter = "";
    if(stat_APPROVED){
      statusFilter = "APPROVED";
    }
    if(stat_INPROGRESS){
      statusFilter += (statusFilter.length > 0) ? ",APPROVAL IN-PROGRESS" : "APPROVAL IN-PROGRESS";
    }
    if(stat_COMPLETED){
      statusFilter += (statusFilter.length > 0) ? ",COMPLETED" : "COMPLETED";
    }
    if(stat_REJECTED){
      statusFilter += (statusFilter.length > 0) ? ",REJECTED" : "REJECTED";
    }
    if(stat_DECLINED){
      statusFilter += (statusFilter.length > 0) ? ",USER DECLINED ATTESTATION" : "USER DECLINED ATTESTATION";
    }    
    if(stat_RFDECLINED){
      statusFilter += (statusFilter.length > 0) ? ",DECLINED" : "DECLINED";
    } 
    
    onShowAdd(statusFilter);
  }

  return (
    <Box mt={2} mb={2}>
      <Grid container direction="row" spacing={2}>
        <Grid item container xs={12} justify="flex-end">
          <Grid item xs={3}>
            <Search
              onSearchUpdate={onSearchUpdate}
              placeholder={"Search by Reference No., RFNo., Requestor, User"}
              defaultValue={searchValue}
            ></Search>
          </Grid>
        </Grid>
        
        <Grid item container xs={12} justify="flex-end">          
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setOpen(true)}
          >
            Filters
          </Button>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              dispatch({ type: CLEAR_FILTERS_DATA });
              form.reset();
              setSearchValue("");
            }}
            style={{ marginLeft: "40px" }}
          >
            Reset Filters
          </Button>
        </Grid>
      </Grid>
      <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="flex-end"
          >
          <Form.Checkbox
            label="APPROVED"
            name="status_approved"
            onChange={(name, value) => {setAPPROVED(value)}}
            size={1}
            value={stat_APPROVED}
          />
          <Form.Checkbox
            label="APPROVAL IN-PROGRESS"
            name="status_inprogress"
            onChange={(name, value) => {setINPROGRESS(value)}}
            size={2}
            value={stat_INPROGRESS}
          />
          <Form.Checkbox
            label="COMPLETED"
            name="status_completed"
            onChange={(name, value) => {setCOMPLETED(value)}}
            size={1}
            value={stat_COMPLETED}
          />
          <Form.Checkbox
            label="REJECTED"
            name="status_rejected"
            onChange={(name, value) => {setREJECTED(value)}}
            size={1}
            value={stat_REJECTED}
          />
          <Form.Checkbox
            label="USER DECLINED ATTESTATION"
            name="status_declined"
            onChange={(name, value) => {setDECLINED(value)}}
            size={3}
            value={stat_DECLINED}
          />
           <Form.Checkbox
            label="DECLINED"
            name="status_rfdeclined"
            onChange={(name, value) => {setRFDECLINED(value)}}
            size={3}
            value={stat_RFDECLINED}
          />
          <Button
            variant="contained"
            color="primary"
            type="button"
            onClick={filterByStatus}
            style={{ marginTop: "10px" }}
          >
            Filter by Status
          </Button>
        </Grid>
      <UAMFilters
        open={open}
        requests={rows}
        form={form}
        onApply={(filters: Filters) => {
          setOpen(false);
          dispatch({ type: UPDATE_FILTERS_DATA, filtersData: filters });
        }}
        onCancel={() => {
          setOpen(false);
        }}
      />
      <Modal
        closeModal={() => setOpenApprove(false)}
        title={"Approve Request"}
        isOpen={openApprove}
        buttonText="APPROVE REQUEST"
        successMessage="Successfully Approved"
        onAction={onSubmitApproval}
      ></Modal>
    </Box>
  );
};
